import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import CustomFieldService from "../../services/CustomFieldService";

import {
  sectionListSuccess,
  sectionListFail,
  sectionDetailsSuccess,
  sectionDetailsFail,
  sectionCreateSuccess,
  sectionCreateFail,
  sectionUpdateDetailSuccess,
  sectionUpdateDetailFail,
  sectionUpdateOrderSuccess,
  sectionUpdateOrderFail,
  fieldCreateSuccess,
  fieldCreateFail,
  fieldUpdateOrderSuccess,
  fieldUpdateOrderFail,
  fieldUpdateSuccess,
  fieldUpdateFail,
  deleteFieldSuccess,
  deleteFieldFail,
  deleteSectionSuccess,
  deleteSectionFail,
} from "../slices/customFieldSlice";

function* listSections() {
  try {
    const ajax = yield call(CustomFieldService.listSections);
    if (ajax.status === 200) {
      yield put(sectionListSuccess(ajax.data));
    } else {
      yield put(
        sectionListFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sectionListFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* createSection(data) {
  try {
    const ajax = yield call(CustomFieldService.createSection, data.payload);
    if (ajax.status === 200) {
      yield put(sectionCreateSuccess(ajax.data));
    } else {
      yield put(
        sectionCreateFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sectionCreateFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* sectionDetails(data) {
  try {
    const ajax = yield call(CustomFieldService.sectionDetails, data.payload);
    if (ajax.status === 200) {
      yield put(sectionDetailsSuccess(ajax.data));
    } else {
      yield put(
        sectionDetailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sectionDetailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateSection(data) {
  try {
    const ajax = yield call(CustomFieldService.updateSection, data.payload);
    if (ajax.status === 200) {
      yield put(sectionUpdateDetailSuccess(ajax.data));
    } else {
      yield put(
        sectionUpdateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sectionUpdateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateSectionOrder(data) {
  try {
    const ajax = yield call(
      CustomFieldService.updateSectionOrder,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(sectionUpdateOrderSuccess(ajax.data));
    } else {
      yield put(
        sectionUpdateOrderFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      sectionUpdateOrderFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* createCustomField(data) {
  try {
    const ajax = yield call(CustomFieldService.create, data.payload);
    if (ajax.status === 200) {
      yield put(fieldCreateSuccess(ajax.data));
    } else {
      yield put(
        fieldCreateFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      fieldCreateFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateCustomFieldOrder(data) {
  try {
    const ajax = yield call(CustomFieldService.updateFieldOrder, data.payload);
    if (ajax.status === 200) {
      yield put(fieldUpdateOrderSuccess(ajax.data));
    } else {
      yield put(
        fieldUpdateOrderFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      fieldUpdateOrderFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateField(data) {
  try {
    const ajax = yield call(CustomFieldService.update, data.payload);
    if (ajax.status === 200) {
      yield put(fieldUpdateSuccess(ajax.data));
    } else {
      yield put(
        fieldUpdateFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      fieldUpdateFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* deleteSection(data) {
  try {
    const ajax = yield call(CustomFieldService.deleteSection, data.payload);
    if (ajax.status === 200) {
      yield put(deleteSectionSuccess(ajax.data));
    } else {
      yield put(
        deleteSectionFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      deleteSectionFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* deleteField(data) {
  try {
    const ajax = yield call(CustomFieldService.delete, data.payload);
    if (ajax.status === 200) {
      yield put(deleteFieldSuccess(ajax.data));
    } else {
      yield put(
        deleteFieldFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      deleteFieldFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* customFieldSaga() {
  yield all([
    takeLatest("customFields/sectionListRequest", listSections),
    takeLatest("customFields/sectionCreateRequest", createSection),
    takeLatest("customFields/sectionDetailsRequest", sectionDetails),
    takeLatest("customFields/sectionUpdateDetailRequest", updateSection),
    takeLatest("customFields/sectionUpdateOrderRequest", updateSectionOrder),
    takeLatest("customFields/fieldCreateRequest", createCustomField),
    takeLatest("customFields/fieldUpdateOrderRequest", updateCustomFieldOrder),
    takeLatest("customFields/fieldUpdateRequest", updateField),
    takeLatest("customFields/deleteFieldRequest", deleteField),
    takeLatest("customFields/deleteSectionRequest", deleteSection),
  ]);
}
